import { SEVERITY } from './constants';
import ConsoleLoggerEngine from './engines/console-logger-engine';
let loggerConfig = {
    engine: ConsoleLoggerEngine(),
};
function initLogger(config) {
    loggerConfig = config;
    config.engine.init();
}
function getLogger() {
    return loggerConfig.engine;
}
const logger = Object.freeze({
    log: (messageOrEntry, context) => {
        var _a;
        if (typeof messageOrEntry === 'object') {
            getLogger().log(messageOrEntry);
        }
        else {
            getLogger().log({
                message: messageOrEntry,
                level: (_a = loggerConfig === null || loggerConfig === void 0 ? void 0 : loggerConfig.logLevel) !== null && _a !== void 0 ? _a : SEVERITY.info,
                context,
            });
        }
    },
    debug: (message, context) => getLogger().log({ message, level: SEVERITY.debug, context }),
    info: (message, context) => getLogger().log({ message, level: SEVERITY.info, context }),
    warn: (message, context) => getLogger().log({ message, level: SEVERITY.warning, context }),
    error: (message, context) => getLogger().log({ message, level: SEVERITY.error, context }),
    logException: (exception, context) => getLogger().logException(exception, context),
    setUser: (user) => getLogger().setUser(user),
    clearUser: () => getLogger().clearUser(),
    /** @function
     * @name setTag
     * @param key max length 32 char
     * @param value max length 200 char
     */
    setTag: (key, value) => getLogger().setTag(key, value),
    setTags: (tags) => getLogger().setTags(tags),
    setContext: (name, ctx) => getLogger().setContext(name, ctx),
});
export { logger, initLogger, ConsoleLoggerEngine, };
//# sourceMappingURL=base.js.map